<template>
    <div>
        <div class="selects">
            <div class="select-parent">
                <!-- 筛选条件两个层级 -->
                <template v-if="searchItem.label === 2">
                    <div @click="selectParent(select, selectIndex)"
                        v-for="(select, selectIndex) in searchItem.selectList"
                        :class="`select-item ${activeParentIndex === selectIndex && 'active'}`">
                        <span class="setlecTitle" v-if="device === 'mb'" v-html="formatTextWithLineBreak(select[searchItem.key])">
                        </span>
                        <span v-else>
                             {{ select[searchItem.key] }}
                        </span>
                        <span class="selectNum"
                            v-if="searchItem.selectedCode[select[searchItem.code]] && searchItem.selectedCode[select[searchItem.code]].length">
                            {{ searchItem.selectedCode[select[searchItem.code]].length }}
                        </span>
                    </div>
                </template>
                <!-- 筛选条件一个层级 -->
                <template v-else>
                    <CheckboxGroup @change="changeSelect(searchItem)" v-model="searchItem.selectedCode.allValue"
                        shape="square" checked-color="#c028b9">
                        <div class="select-item" v-for="(childrenItem, childrenIndex) in searchItem.selectList">
                            <Checkbox :name="childrenItem[searchItem.code]">
                                {{ childrenItem[searchItem.key] }}
                            </Checkbox>
                        </div>
                    </CheckboxGroup>
                </template>
            </div>
            <div
                :class="`select-children ${activeParentSelect[searchItem.childrenKey] && activeParentSelect[searchItem.childrenKey].length ? '' : 'no-children'}`">
                <template
                    v-if="activeParentSelect[searchItem.childrenKey] && activeParentSelect[searchItem.childrenKey].length">
                    <div class="select-item"  v-if="searchItem.showSelectAll" >
                        <Checkbox checked-color="#c028b9"
                            @click="checkAllChange"
                            v-model="activeParentSelect.selectAll"
                            :indeterminate="activeParentSelect.isIndeterminate">
                            <span class="select-all">
                              {{ $t('searchJob.selectAll') }}
                            </span>
                        </Checkbox>
                    </div>
                    <CheckboxGroup @change="changeSelect(searchItem)"
                        v-model="searchItem.selectedCode[activeParentSelect[searchItem.code]]" shape="square"
                        checked-color="#c028b9">
                        <div class="select-item"
                            v-for="(childrenItem, childrenIndex) in activeParentSelect[searchItem.childrenKey]">
                            <Checkbox :name="childrenItem[searchItem.code]">
                                {{ childrenItem[searchItem.key] }}
                            </Checkbox>
                        </div>
                    </CheckboxGroup>
                </template>
            </div>
        </div>
         <div class="selects-buttons">
            <Button color="#000000" plain type="primary" @click="resetFilter">{{ $t('searchJob.reset') }}</Button>
            <Button color="#c028b9" type="primary" @click="confirmSelect">{{ $t('searchJob.confirm') }}</Button>
        </div>
    </div>
   
</template>

<script setup>
import { Checkbox, CheckboxGroup, Button } from 'vant';
import { inject, ref, watch } from 'vue'
const device = inject("device");

const props = defineProps({
    searchItem: {
        type: Object,
        default: () => {
            return {}
        }
    }
})
const emit = defineEmits(['resetFilter', 'confirmSelect'])

const activeParentIndex= ref(0)
const activeParentSelect= ref({})
const selectParent = (select, selectIndex) => {
    activeParentIndex.value = selectIndex
    // 是否展示全选
    activeParentSelect.value = select
    if(props.searchItem.showSelectAll && props.searchItem.label === 2) {
        activeParentSelect.value.selectAll = activeParentSelect.value[props.searchItem.childrenKey]?.length === props.searchItem.selectedCode[activeParentSelect.value[props.searchItem.code]]?.length
        activeParentSelect.value.isIndeterminate = props.searchItem.selectedCode[activeParentSelect.value[props.searchItem.code]]?.length > 0 && props.searchItem.selectedCode[activeParentSelect.value[props.searchItem.code]]?.length !== activeParentSelect.value[props.searchItem.childrenKey]?.length
    }
}
const checkAllChange =() =>{
    props.searchItem.selectedCode[activeParentSelect.value[props.searchItem.code]] = activeParentSelect.value.selectAll ? activeParentSelect.value[props.searchItem.childrenKey].map(item => item[props.searchItem.code]) : []
    activeParentSelect.value.isIndeterminate = false
}
const changeSelect = (searchItem) => {
    if (searchItem.label === 2) {
        let selectedCode = []
        let keys = Object.keys(searchItem.selectedCode)
        keys.forEach(key => {
            if (key !== 'allValue') {
                selectedCode = selectedCode.concat(searchItem.selectedCode[key])
            }
        })
        searchItem.selectedCode.allValue = [...selectedCode]
        if (searchItem?.showSelectAll) {
            activeParentSelect.value.selectAll = activeParentSelect.value[searchItem.childrenKey]?.length === searchItem.selectedCode[activeParentSelect.value[searchItem.code]]?.length
            activeParentSelect.value.isIndeterminate = searchItem.selectedCode[activeParentSelect.value[searchItem.code]]?.length > 0 && searchItem.selectedCode[activeParentSelect.value[searchItem.code]]?.length !== activeParentSelect.value[searchItem.childrenKey]?.length
        }
    }
}
const resetFilter = () => {
    emit('resetFilter')
}
const confirmSelect = () => {
    emit('confirmSelect')
}
// 新增：中英文换行处理方法
const formatTextWithLineBreak = (text) => {
    if (!text) return '';

    // 匹配英文部分（字母、数字、空格）
    const englishMatch = text.match(/[a-zA-Z0-9\s]+/g)?.[0]?.trim() || '';
    // 匹配中文部分（中文字符）
    const chineseMatch = text.match(/[\u4e00-\u9fa5]+/g)?.[0]?.trim() || '';

    // 如果同时存在中英文，在中间添加换行
    if (englishMatch && chineseMatch) {
        return `${englishMatch}<br/>${chineseMatch}`;
    }

    // 如果只有一种语言，返回原文本
    return text;
}
watch(() => props.searchItem, (newVal, oldVal) => {
    if (newVal?.label === 2) {
        selectParent(newVal.selectList[activeParentIndex.value], activeParentIndex.value)
    }
}, {
    immediate: true
})

</script>

<style lang='scss' scoped>
.selects {
    min-width: 384px;
    display: flex;
    flex-wrap: wrap;
    .select-parent {
        padding-top: 16px;
        background-color: #fbf9f9;
        min-width: 192px;
        // width: 50%;
        max-height: 300px;
        overflow-y: auto;
    }

    .select-children {
        padding-top: 16px;
        background-color: #fff;
        min-width: 192px;
        // width: 50%;
        max-height: 300px;
        overflow-y: auto;
        .select-item {
            padding: 10px 20px;
        }
    }
    .no-children{
        background-color: #fbf9f9;
    }


}
        .selects-buttons {
            width: 100%;
            display: flex;
            justify-content: space-around;
            padding: 16px 20px;
            background-color: #fbf9f9;
    
            .van-button+.van-button {
                margin-left: 16px;
            }
    
            .van-button--normal {
                flex: 1;
                width: 0;
                height: 40px;
                border-radius: 0;
                background: transparent;
            }
        }

.select-item {
        line-height: 22px;
        width: 100%;
        padding: 9px 20px;
        color: #4D5660;
        display: flex;
        align-items: center;
        border-right: 2px solid #fbf9f9;
        .setlecTitle{
            flex:1
        }

    .selectNum {
        background-color: var(--hc-color--bright-purple);
        width: 16px;
        height: 16px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 0.75rem;
        margin-left: 8px;
    }
}
.select-all {
    color: #c028b9;
}

.select-item.active {
    color: #000;
    background-color: #F0E9E6;
    border-right: 2px solid var(--hc-color--bright-purple);
}

:deep(.van-checkbox__icon .van-icon) {
    border-radius: 2px;
}

:deep(.van-checkbox .van-checkbox__label) {
    color: #4D5660;
}

:deep(.van-checkbox[aria-checked="true"] .van-checkbox__label) {
    color: #000;
}

@media (max-width: 767px) {
    .selects {
        width: 100%;

        .select-parent {
            padding-top: 10px;
            width: 50%;
        }

        .select-children {
            padding-top: 10px;
            width: 50%;
        }

        .select-item {
            width: 100%;
            .setlecTitle {
                    font-size: 1rem;
                }
        }
                :deep(.van-checkbox .van-checkbox__label) {
                    font-size: 1rem;
                }
    }
}
</style>